import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { useLocation } from "react-router-dom";
import { getpatientMedicationsAPI } from "../../../../services/patient.services";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import AddMedicineTable from "../../../PatientsIP/MedicationsIp/AddMedicineTable";
import MedicationHistoryChart from "../../../PatientsIP/MedicationsIp/MedicationHistoryChart";
import "../InitialInspection/InitialInspectionHeader.css";

const MedicinesInitial = ({ setCurrent, patientData }) => {
  const location = useLocation();
  const params = Object.fromEntries(new URLSearchParams(location?.search));
  const [data, setData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);

  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };

  useEffect(() => {
    setLoading(true);
    getpatientMedicationsAPI(`ip_admission=${params?.patient}`)
      .then((res) => {
        setData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [refresh, params?.patient]);

  return (
    <>
      <div className="ia-step-shell ia-step-shell--medicine">
        <div className="ia-form-panel">
          <div className="ia-form-body">
            <AddMedicineTable
              data={data}
              setData={setData}
              refreshPage={refreshPage}
              loading={loading}
              initial={true}
              setHistoryModal={setHistoryModal}
            />
          </div>
          <div className="ia-form-footer">
            <Button
              type="primary"
              className={btnStyles.mdBtn}
              style={{ fontWeight: 500 }}
              onClick={() => setCurrent(3)}
            >
              Proceed
            </Button>
          </div>
        </div>
      </div>
      {historyModal && (
        <MedicationHistoryChart
          open={historyModal}
          setOpen={setHistoryModal}
          data={data}
          params={params}
          patientData={patientData?.admission || patientData}
        />
      )}
    </>
  );
};

export default MedicinesInitial;
